<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
      <el-form-item prop="userId" v-if="adminShow">
        <el-select v-model="queryParams.userId" filterable placeholder="代理商" @change="search" clearable>
            <el-option v-for="item in webAgentList" :key="item.userId" :label="'['+item.username+']-'+item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="poolName" v-if="adminShow">
        <el-input v-model="queryParams.poolName" placeholder="流量池名称"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="poolType" v-if="adminShow">
        <el-select v-model="queryParams.poolType" filterable placeholder="流量池类型" @change="search" clearable>
          <el-option v-for="item in modeOperator" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 250px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="账单开始日期"
          end-placeholder="账单结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-down" v-if="adminShow" @click="down" v-hasPermi="['pondManage:record:down']">下载</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border style="width: 100%" :row-class-name="getRowClass" :default-expand-all="false" @selection-change="handleSelectionChange">
      <el-table-column type="selection" v-if="adminShow" align="center" :selectable="typeSelect"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form v-if="props.row.consumeType =='7' || props.row.consumeType =='6' " label-position="left"  class="pond-table-expand" :inline="true" style="width:600px">
            <el-form-item label="总流量（MB）">
              <span>{{ props.row.totalFlow }}MB</span>
            </el-form-item>
            <el-form-item label="总价格（元）">
              <span>{{ props.row.totalFee }}元</span>
            </el-form-item>
          </el-form>
          <AssetPoolRecord v-else :poolProductId="props.row.id"></AssetPoolRecord>
        </template>
      </el-table-column>

      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="companyName" label="代理商" align="center" min-width="260" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="poolName" label="流量池名称" align="center" min-width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="poolType" label="流量池类型" align="center"  min-width="120" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <span v-if="row.poolType ==='1'">单卡模式</span>
          <span v-else-if="row.poolType ==='2'">总量模式</span>
          <span v-else-if="row.poolType ==='3'">套餐模式</span>
          <span v-else-if="row.poolType ==='5'">后付款模式</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="consumeType" label="费用项名称" align="center" min-width="120" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <span v-if="row.consumeType ==='7'">加油包</span>
          <span v-else-if="row.consumeType ==='6'">续费</span>
          <span v-else-if="row.consumeType ==='9'">卡续约</span>
          <span v-else>月套餐费用</span>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="账单周期" align="center" :show-overflow-tooltip="true" :formatter="dateFormatDateMonth" ></el-table-column>
      <el-table-column prop="totalFee" label="扣费金额(元)" align="center" min-width="120" ></el-table-column>
      <el-table-column prop="payMode" label="支付方式" align="center">
        <template slot-scope="{row}">
          <span v-if="row.payMode ==='1' &&　(row.consumeType ==='7' || row.consumeType ==='6' || row.consumeType ==='9')">微信支付</span>
          <span v-else-if="row.payMode ==='2' &&　(row.consumeType ==='7' || row.consumeType ==='6' || row.consumeType ==='9')">支付宝支付</span>
          <span v-else-if="row.payMode ==='3' &&　(row.consumeType ==='7' || row.consumeType ==='6' || row.consumeType ==='9')">余额支付</span>
          <span v-else-if="row.payMode ==='4' &&　(row.consumeType ==='7' || row.consumeType ==='6' || row.consumeType ==='9')">系统支付</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderTime" label="创建时间" align="center" min-width="160" :show-overflow-tooltip="true"  ></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.consumeType =='6' || scope.row.consumeType =='7'">无</span>
          <el-button v-else-if="scope.row.consumeType ==='9'" size="mini" type="primary" plain icon="el-icon-view" @click="selectPoolCards(scope.row.userAssetDetailPoolId)" v-hasPermi="['pondManage:record:detail']">查看</el-button>
          <el-button v-else size="mini" type="primary" icon="el-icon-down" plain  @click="poolDown(scope.row.id)" v-hasPermi="['pondManage:record:down']">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <el-dialog title="卡列表" width="800px" :visible.sync="showDialog" @close="dialogClose" v-dialogDrag :modal-append-to-body="false" :close-on-click-modal="false">
        <el-table :data="cardList" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}">
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
        </el-table>
        <pagination
          v-show="poolCardTotal>0"
          :total="poolCardTotal"
          :page.sync="poolCardPage"
          :limit.sync="poolCardPageSize"
          @pagination="initPoolCardData"
        />
    </el-dialog>
  </div>
</template>
<script>
import { userAssetDetailPoolList,userAssetDetailPoolDown,userAssetDetailPoolCards} from "@/api/api.js";
import { agentDataList } from "@/api/api.js";
import AssetPoolRecord from "./order/AssetPoolRecord.vue";
export default {
  name:'pondConsumeRecordList',
  components: { 
    AssetPoolRecord
  },
  data() {
    return{
      // 选中数组
      poolProductIds: [],
      queryParams:{
        userId:undefined,
        poolName:undefined,
        poolType:undefined,
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      dateRange:[],
      webAgentList:[],
      modeOperator:[
        { value:"1",label:"单卡模式" },
        { value:"2",label:"总量模式" },
        { value:"3",label:"套餐模式" },
        { value:"5",label:"后付款模式" },
      ],
      showDialog:false,
      userAssetDetailPoolId:undefined,
      poolCardTotal:0,
      poolCardPage:1,
      poolCardPageSize:10,
      cardList:[]
    }
  },
  computed: {
    adminShow() {
      return this.$store.getters.user.userType =='1'
    }
  },
  watch:{
    $route: {
      handler: function(to, from){
        if(to.name == 'pondConsumeRecordList'){
          this.search();
        }
      },
      immediate:true
    }
  },
  methods:{
    down(){
      this.queryParams.poolProductIds = this.poolProductIds
      userAssetDetailPoolDown(this.queryParams).then(res=>{
        this.$notify({
            title: "成功",
            message: "列表导出成功，请在任务中心查看",
            type: "success",
            offset:30
          });
      })
    },
    poolDown(poolProductid){
       this.poolProductIds = [poolProductid] 
       this.down()
    },
    getRowClass({row, rowIndex}) {
      if(row.consumeType=='9'){
        return 'row-expand-cover';
      } else  {
        return '';
      }
    },
    //判断是否可以被选中
    typeSelect(row,index){
      return row.consumeType !='6' && row.consumeType !='7' && row.consumeType !='9';
    },
    // 多选单选的值
    handleSelectionChange(selection){
      this.poolProductIds = selection.map(item => item.id);
    },
    dateFormatDateMonth(row){
      let dt = new Date(row.startTime);
      let year = dt.getFullYear();
      let month = dt.getMonth() + 1;
      return `${year}${month < 10 ? '0' + month : month}`
    },
    dateFormatDate(time){
      let dt = new Date(time);
      return this.dataFormat(dt);
    },
    dateFormatDateStartTime(row){
      let dt = new Date(row.orderTime);
      return this.dataFormat(dt);
    },
    dataFormat(dt){
      let year = dt.getFullYear();
      let month = dt.getMonth() + 1;
      let date = dt.getDate();
      return `${year}-${month}-${date}`;
    },
    poolTotalFlowFormat(row){
      return row.poolTotalFlow === 'nullM' ?"-":row.poolTotalFlow;
    },
    expireTimeFormat(row){
      return row.expireTime == null ?"-":row.expireTime;
    },
    // 获取列表的数据
    initData(){
      let params= {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange)
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      userAssetDetailPoolList(params).then(res=>{
        if(res.data.code == 200){
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index) => {
            item.ids = index + 1;
            if(item.poolUseFlow == 0){
              item.poolUseFlow =  '0';
            }else if(1024 > item.poolUseFlow > 0){
              item.poolUseFlow =  item.poolUseFlow + 'M';
            }else if(item.poolUseFlow >= 1024){
              item.poolUseFlow =  (item.poolUseFlow / 1024).toFixed(2) + 'G';
            };
            if(item.poolTotalFlow == -1){
              item.poolTotalFlow =  '未设置';
            }else if(item.poolTotalFlow == 0){
              item.poolTotalFlow =  '0';
            }else if(1024 > item.poolTotalFlow > 0){
              item.poolTotalFlow =  item.poolTotalFlow + 'M';
            }else if(item.poolTotalFlow >= 1024){
              item.poolTotalFlow =  (item.poolTotalFlow / 1024).toFixed(2) + 'G';
            }
            if(item.singleFlowLimit == 0){
              item.singleFlowLimit =  '0';
            }else if(1024 > item.singleFlowLimit > 0){
              item.singleFlowLimit =  item.singleFlowLimit + 'M';
            }else if(item.singleFlowLimit >= 1024){
              item.singleFlowLimit =  (item.singleFlowLimit / 1024).toFixed(2) + 'G';
            };
          })
        }
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    add(){
      this.$router.push({ path: `/pondManage/pondAdd` });
    },
    // 详情
    details(row){
      this.$router.push({ path: `/pondManage/pondDetails?userId=${row.userId}`});
    },
    editRow(row){
      this.$router.push({ path: `/pondManage/pondEdit?poolId=${row.poolId}`});
    },
    // 获取流量池用户
    selectPoolAgent(){
      agentDataList({commissionModel:'2'}).then(res => {
        this.webAgentList = res.data.data
      })
    },
    dialogClose(){
      this.showDialog = false
    },
    selectPoolCards(userAssetDetailPoolId){
      this.userAssetDetailPoolId = userAssetDetailPoolId
      this.showDialog = true
      this.initPoolCardData()
    },
    initPoolCardData(){
      let params= {
        model:{
          userAssetDetailPoolId:this.userAssetDetailPoolId
        },
        page: this.poolCardPage,
        pageSize: this.poolCardPageSize,
      }
      userAssetDetailPoolCards(params).then(res=>{
        this.cardList = res.data.data.records;
        this.poolCardTotal = res.data.data.total;
      })
    }
    
  },
  mounted() {
    this.initData();
    this.selectPoolAgent()
  },
  created() {
    
  }
};
</script>
<style lang="less" scoped>
 /deep/ .row-expand-cover .el-table__expand-icon{visibility:hidden;}
  .pond-table-expand {
    font-size: 0;
    padding: 0px 25px
  }
  .pond-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .pond-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>


